import React, { FC } from 'react';
import FormItemLabel from 'antd/es/form/FormItemLabel';
import { Input } from 'antd';
import s from '../CustomSwitch/CustomSwitch.module.scss';
interface ICustomInput {
  label: string;
  name: string;
  value: string;
  disabled?: boolean;
  handleChange: (name: string, value: string | boolean | number) => unknown;
  handleSaveXPath?: () => unknown;
}
export const CustomInput: FC<ICustomInput> = ({
  label,
  name,
  value,
  disabled,
  handleChange,
  handleSaveXPath,
}) => {
  return (
    <div className={s.CustomSwitch}>
      <FormItemLabel prefixCls={label} label={label} htmlFor={name} />
      <Input
        disabled={disabled}
        name={name}
        value={value}
        onChange={(e) => handleChange(name, e.target.value)}
        placeholder={label}
        onBlur={handleSaveXPath}
      />
    </div>
  );
};
